import React, { useState, useEffect, useRef } from 'react';
import Tag from '../../components/ui/Tag';
import ElixirImage from '../../../public/images/TEAM.webp';
import ElixirImage2 from '../../../public/images/tunisian-landscape.webp';

import Button from '@/components/ui/Button';
const WorkflowSteps = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [titleVisible, setTitleVisible] = useState(false);
  const [paraVisible, setParaVisible] = useState(false);
  const [imgVisible, setImgVisible] = useState(false);
  const sectionRef = useRef(null);
  const handleRequestServices = () => {
    navigate('/request-a-demo');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  // Intersection Observer setup
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true); // Section is in view
          }
        });
      },
      {
        threshold: 0.3, // 50% of the section must be in view
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current); // Observe the section
    }

    // Cleanup observer on unmount
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Trigger individual animations after section is visible
  useEffect(() => {
    if (isVisible) {
      setTitleVisible(true);
      setTimeout(() => setParaVisible(true), 300); // Delay para animation
      setTimeout(() => setImgVisible(true), 600); // Delay image animation
    }
  }, [isVisible]);

  return (
    <section
      ref={sectionRef}
      className={`bg-white section-spacing transition-all duration-1000 ease-in-out ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div className="container mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row items-center justify-center gap-10 mt-8">
          {/* Text Content */}
          <div className="w-full md:w-1/2 text-left px-4 md:px-0">
            <h2
              className={`text-3xl md:text-3xl lg:text-3xl font-extralight text-[#000000] mb-6`}
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Rooted in Tradition, Crafted with Passion.
            </h2>
            <ul className="space-y-4 text-lg text-[#333]">
              <li>
                For generations, the art of beekeeping has thrived in Tunisia's sun-drenched lands.
                Adami Apiculture was born from a desire to share this golden heritage, selecting the
                finest nectars and crafting Elixir with unwavering dedication to quality and
                authenticity.
              </li>
            </ul>
          </div>
          {/* Image */}
          <div
            className={`w-full  md:w-1/2 transition-all duration-1000 ${
              imgVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <img
              src={ElixirImage}
              alt="Elixir Eucalyptus"
              className="rounded-lg w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl h-64 md:h-80 object-cover mx-auto"
            />
          </div>
        </div>
        <div className="flex flex-col md:flex-row items-center justify-center gap-10 mt-16">
          {/* Text Content */}
          <div className="w-full md:w-1/2 text-left px-4 md:px-0">
            <h2
              className={`text-3xl md:text-3xl lg:text-3xl font-extralight text-[#000000] mb-6`}
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              A Taste of Tunisia's Unique Landscapes.
            </h2>
            <ul className="space-y-4 text-lg text-[#333]">
              <li>
                From wild thyme to fragrant eucalyptus, each Elixir variety captures the distinct
                flavors and benefits of Tunisia's diverse flora.
              </li>
            </ul>
          </div>
          {/* Image */}
          <div
            className={`w-full  md:w-1/2 transition-all duration-1000 ${
              imgVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <img
              src={ElixirImage2}
              alt="Elixir Eucalyptus"
              className="rounded-lg w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl h-64 md:h-80 object-cover mx-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkflowSteps;
